import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/hero3.png";
import About from "../components/About";
import Brands from "../components/Brands";
import Faqs from "../components/Faqs";
import WhyChoose from "../components/WhyChoose";
import Services from "../components/Services";
import ServiceShowcase from "../components/ServiceShowcase";
import "./AreaPage.css";

const AREA_SEO_CONTENT = {
  "koramangala": {
    title: "Appliance Repair Services in Koramangala Bangalore",
    description:
      "Professional appliance repair service in Koramangala for refrigerators, washing machines, microwaves, and other household appliances.",
    keywords:
      "appliance repair koramangala, home appliance service koramangala, samsung service in koramangala",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-koramangala",
    robots: "index, follow",
  },
  "hsr-layout": {
    title: "Appliance Repair in HSR Layout Bangalore",
    description:
      "Reliable appliance repair service in HSR Layout for refrigerators, washing machines, microwaves, and kitchen appliances with fast support.",
    keywords:
      "appliance repair hsr layout, appliance service hsr layout, washing machine repair hsr layout",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-hsr-layout",
    robots: "index, follow",
  },
  "electronic-city": {
    title: "Appliance Repair in Electronic City Bangalore",
    description:
      "Expert appliance repair service in Electronic City for refrigerators, washing machines, and home appliances with same-day assistance.",
    keywords:
      "appliance repair electronic city, appliance service electronic city, washing machine repair bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-electronic-city",
    robots: "index, follow",
  },
  "whitefield": {
    title: "Appliance Repair Services in Whitefield Bangalore",
    description:
      "Professional appliance repair service in Whitefield, Bangalore with same-day doorstep support available.",
    keywords:
      "appliance repair whitefield, appliance service whitefield, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-whitefield",
    robots: "index, follow",
  },
  "mahadevapura": {
    title: "Appliance Repair in Mahadevapura Bangalore",
    description:
      "Affordable appliance repair service in Mahadevapura for washing machines, refrigerators, microwaves, and household appliances.",
    keywords:
      "appliance repair mahadevapura, appliance service mahadevapura, appliance service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-mahadevapura",
    robots: "index, follow",
  },
  "jayanagar": {
    title: "Appliance Repair Services in Jayanagar Bangalore",
    description:
      "Trusted appliance repair service in Jayanagar offering quick repairs for refrigerators, washing machines, microwaves, and more.",
    keywords:
      "appliance repair jayanagar, appliance service jayanagar, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-jayanagar",
    robots: "index, follow",
  },
  "rajajinagar": {
    title: "Appliance Repair in Rajajinagar Bangalore",
    description:
      "Professional appliance repair service in Rajajinagar with expert technicians for refrigerator, washing machine, and microwave repairs.",
    keywords:
      "appliance repair rajajinagar, appliance service rajajinagar, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-rajajinagar",
    robots: "index, follow",
  },
  "malleswaram": {
    title: "Appliance Repair Services in Malleswaram Bangalore",
    description:
      "Fast appliance repair service in Malleswaram, Bangalore with professional support for all appliances.",
    keywords:
      "appliance repair malleswaram, appliance service malleswaram, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-malleswaram",
    robots: "index, follow",
  },
  "marathahalli": {
    title: "Appliance Repair in Marathahalli Bangalore",
    description:
      "Get expert appliance repair service in Marathahalli for refrigerators, washing machines, microwaves, and other home appliances.",
    keywords:
      "appliance repair marathahalli, appliance service marathahalli, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-marathahalli",
    robots: "index, follow",
  },
  "jp-nagar": {
    title: "Appliance Repair Services in JP Nagar Bangalore",
    description:
      "Fast and affordable appliance repair service in JP Nagar for refrigerators, washing machines, microwaves, and kitchen appliances.",
    keywords:
      "appliance repair jp nagar, appliance service jp nagar, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-jp-nagar",
    robots: "index, follow",
  },
  "banashankari": {
    title: "Appliance Repair in Banashankari Bangalore",
    description:
      "Professional appliance repair service in Banashankari with experienced technicians for refrigerator and washing machine repairs.",
    keywords:
      "appliance repair banashankari, appliance service banashankari, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-banashankari",
    robots: "index, follow",
  },
  "kr-puram": {
    title: "Appliance Repair Services in KR Puram Bangalore",
    description:
      "Trusted appliance repair service in KR Puram offering quick solutions for refrigerators, washing machines, and microwaves.",
    keywords:
      "appliance repair kr puram, appliance service kr puram, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-kr-puram",
    robots: "index, follow",
  },
  "btm-layout": {
    title: "Appliance Repair Services in BTM Layout Bangalore",
    description:
      "Expert appliance repair service in BTM Layout for refrigerators, washing machines, microwaves, and all major home appliances.",
    keywords:
      "appliance repair btm layout, appliance service btm layout, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-btm-layout",
    robots: "index, follow",
  },
};

const AreaPage = () => {
  const { area: areaParam } = useParams();
  const { pathname } = useLocation();

  let area = areaParam;

  if (!area) {
    const prefix = "/appliance-repair-service-in-";

    if (pathname.startsWith(prefix)) {
      area = pathname.slice(prefix.length);
    }
  }

  area = (area || "").split("/")[0];

  const areaName = area
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

  const seo = AREA_SEO_CONTENT[area] || {
    title: `Appliance Repair Services in ${areaName} Bangalore`,
    description: `Expert appliance repair services in ${areaName}, Bangalore for washing machines, refrigerators, ACs, and other home appliances.`,
    keywords: `appliance repair ${areaName}, appliance service ${areaName}, home appliance repair Bangalore`,
    canonical: `https://customersupports24x7.in/appliance-repair-service-in-${area}`,
    robots: "index, follow",
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [area]);

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta name="robots" content={seo.robots} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta
          property="og:image"
          content="https://customersupports24x7.in/customerSupport.png"
        />
        <meta property="og:url" content={seo.canonical} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
        <meta
          name="twitter:image"
          content="https://customersupports24x7.in/customerSupport.png"
        />
        <link rel="canonical" href={seo.canonical} />
      </Helmet>

      <main className="area-page">
        <div className="brand-service-banner">
          <InnerBanner
            title={`Appliance Repair Service in ${areaName}`}
            bgImage={serviceBg}
          />
        </div>

        <About />
        <Services />
        <Brands />
        <WhyChoose />
        <ServiceShowcase />
        <Faqs />
      </main>
    </>
  );
};

export default AreaPage;
